module.exports = "/images/nf.svg?4c3736bd396f745d7bdd17b61ba50cf3";